angular.module('impactx.deliveryadvice').controller('DeliveryAdviceCtrl', [
    '$scope',
    'BackService',
    'dataGen',
    '$mdToast',
    'WarningService',
    'TranslationService',
    'ToolbarService',
    DeliveryAdviceCtrl
]);

function DeliveryAdviceCtrl($scope, BackService, dataGen, $mdToast, WarningService, TranslationService, ToolbarService) {
    $scope.selectedItems = [];
    $scope.headerSelection = {};
    $scope.overviewOption = {overview: true};
    var ctrl = this;
    var createNewAvi = function () {
        return {aviNo: {value: ""}, deliveryDate: {dateValue: 0}, amount: {value: 0}}
    };

    this.addAvi = function () {
        for (var i = 0; i < $scope.selectedItems.length; i++) {
            var item = $scope.selectedItems[i];
            if (!item.items) {
                item.items = [];
            }
            item.items.push(createNewAvi());
        }
    };

    this.removeAvi = function (itemHeader, avi, index) {
        if (!itemHeader.removedItems) {
            itemHeader.removedItems = [];
        }
        if (avi.id > 0) {
            itemHeader.removedItems.push(avi);
        }
        itemHeader.items.splice(index, 1);
    };

    this.selectedAllOpen = function (items) {
        for (var i = 0; i < items.length; i++) {
            if (!items[i].addAble) {
                return false;
            }
        }
        return true;
    };

    this.checkAndCloseAdvice = function ($event) {
        var header = $scope.headerSelection.selectedHeader;
        var warnings = ctrl.checkWarnings(header);
        if (warnings.length == 0) {
            return ctrl.closeAdvice(header);
        }
        else {
            ctrl.showWarningDialog(header, warnings, ctrl.closeAdvice, $event);
        }
    };

    this.closeAdvice = function (header) {
        var dataObj = {
            avh: header
        };
        return dataGen.postAsForm($scope, dataObj, "/deliveryadvice/close").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.success)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.showWarningDialog = function (header, warnings, callBackFunction, event) {
        WarningService.showWarningDialog(callBackFunction, event, $scope.trns.warning, $scope.trns.saveAnyway,
            $scope.trns.abort, warnings, header);
    };

    this.checkWarnings = function (header) {
        var warnings = [];
        for (var i = 0; i < header.itemHeaders.length; i++) {
            var itemHeader = header.itemHeaders[i];
            var openAmount = itemHeader.openAmount;
            for (var j = 0; j < itemHeader.items.length; j++) {
                var item = itemHeader.items[j];
                openAmount = openAmount - item.amount.value;
            }
            if (itemHeader.items.length > 0 && Math.abs(openAmount) > Math.pow(10, -7)) {
                warnings.push($scope.trns.differentAmount.replace("^0", i + 1));
            }
        }
        return warnings;
    };

    this.updateLabels = function () {
        $scope.zeroNotAllowedLabel = TranslationService.get("zeroNotAllowed");
    };

    ctrl.defineButtons = function () {
        var buttonDefinition = [
            {
                label: $scope.trns.close,
                action: ctrl.checkAndCloseAdvice,
                type: 'validation',
                condition: canClose,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.addAvis,
                action: ctrl.addAvi,
                type: 'dialogaction',
                condition: canAddAvis
            },
            {
                label: $scope.trns.print,
                type: 'print',
                condition: canPrint,
                params: {
                    printTokenFunction: ctrl.getPrintToken,
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    };

    ctrl.getPrintToken = function () {
        return $scope.printTokens['header-' + $scope.headerSelection.selectedHeader.id];
    }

    function canClose() {
        return $scope.headerSelection.selectedHeader && !$scope.headerSelection.selectedHeader.isClosed;
    }

    function canAddAvis() {
        return !$scope.headerSelection.selectedHeader.isClosed && $scope.selectedItems.length > 0 && ctrl.selectedAllOpen($scope.selectedItems);
    }

    function canPrint() {
        return !$scope.data.notExistingAndNoEdit;
    }

    ctrl.getPrintParams = function () {
        return printParams;
    };
}